export const getLocationPayload = location => {
  return { location_id: location.id, location }
}

export const getSelectedLocationId = config => {
  return config?.location_id || config?.location?.id
}
